export default "__VITE_ASSET__1a6d88e9__"